import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import Text from "../../Text";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import List from "../../List";
import "./index.css";
import Subtitle from "../../Subtitle";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useState } from "react";
import Modal from "../../Modal";
import Icon from "../../Icon";
import Image from "../../Image";

interface BenefitsTemplateProps {
  data: DataBenefitsTemplate;
}

const BenefitsTemplate = ({ data }: BenefitsTemplateProps) => {
  const {
    bgImage,
    title,
    titleNumber,
    subtitle,
    text,
    listData,
    next,
    back,
    demoButtons,
    styleListData = {},
    headerRightText,
    headerLeftImage,
    modalImages,
    rightImage,
    rightImageStyle = {},
    showInfoButton = true,
    modalButton,
  } = data;

  const templateType = "benefits-template";

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage("INTRO_0")}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body
        styles={{
          paddingBottom: "120px",
          height: "calc(100% - 287px)",
          paddingTop: "32px",
        }}
      >
        <div className="benefits-container">
          <div className="benefits-top-panel">
            <div className="benefits-title-and-button-container">
              <div className="benefits-title">
                {titleNumber && (
                  <Title
                    type={templateType}
                    text={titleNumber}
                    style={{ color: "#92d1ff" }}
                  />
                )}
                <Title type={templateType} text={title} />
              </div>
              {showInfoButton && modalImages && (
                <div
                  onClick={toggleModal}
                  className="benefits-modal-info-button"
                >
                  <Icon type="info" color="white" />
                </div>
              )}
              {showModal && modalImages && (
                <Modal
                  images={modalImages}
                  onClose={toggleModal}
                  isOpen={showModal}
                />
              )}
            </div>
            <div className="benefits-text">
              {subtitle && <Subtitle type={templateType} text={subtitle} />}
              {text && <Text type={templateType} text={text} />}
              <List
                type={templateType}
                customStyle={styleListData}
                listData={listData}
              />
              {rightImage && (
                <div style={rightImageStyle}>
                  <Image imagePath={rightImage} />
                </div>
              )}
            </div>
          </div>
          <div className="benefits-bottom-panel">
            <ButtonGroups>
              {back && <Button {...back} />}
              {next && <Button {...next} />}
            </ButtonGroups>
            <ButtonGroups>
              {demoButtons &&
                demoButtons.map((button, index) => (
                  <Button key={index} {...button} />
                ))}
              {modalButton && modalImages && (
                <Button
                  onClick={toggleModal}
                  label={modalButton}
                  type="white"
                  endIcon="arrow-right"
                />
              )}
            </ButtonGroups>
          </div>
        </div>
      </Body>
    </BG>
  );
};

export default BenefitsTemplate;
